module.exports = __webpack_public_path__ + "img/administration.f64c227f.png";